import React, { useContext, useState } from "react";
import { Col, Row, Modal, Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";

// Fetch
import { useGetDta } from "../../hooks/useGetDta";

// Components
import Spinner from "../Spinners/Spinner";

// Utils
import toastConfig from "../../utils/toastConfig";
import { fetchWithToken } from "../../api/fetch";
import { ChatContext } from "../../context/chat/ChatContext";
import { SocketContext } from "../../context/SocketContext";
import { AuthContext } from "../../context/AuthContext";

/**
 * Componente para asignar agentes o etiquetas
 *
 * @param {Object} props - Propiedades del componente
 * @param {Boolean} props.show - Estado del modal
 * @param {Function} props.handleClose - Función para cerrar el modal
 * @param {Object} props.info - Información del agente o etiqueta
 * @returns {JSX.Element} Componente de React
 */
const ModalAssign = ({ show, handleClose, info }) => {
  const [selectedOptionId, setSelectedOptionId] = useState(null); // Opción seleccionada

  // Contexto de chat
  const { chatState } = useContext(ChatContext);
  const { activeChat } = chatState;

  // Contexto de autenticación
  const { auth } = useContext(AuthContext);
  const { socket } = useContext(SocketContext);

  // Obtener datos
  const { loading, data } = useGetDta(
    `${info.type === "agente" ? "agentes/all" : "etiquetas/marks"}`
  );
  /**
   * Maneja el guardado de la asignación
   *
   * @returns {void} No retorna nada
   */
  const handleSave = async () => {
    if (info.type === "agente") {
      // Asignar agente
      socket.emit("asignar", {
        agente: selectedOptionId,
        type: "asignado",
        auth: auth.uid,
        id: activeChat.id,
      });

      toast.success("Agente asignado correctamente", toastConfig);
    } else {
      // Asignar etiqueta
      const resp = await fetchWithToken(
        "etiquetas/assign-mark",
        { id: selectedOptionId, id_us: info.id_user },
        "POST"
      );

      // Muestra mensaje de éxito o error
      if (resp.ok) {
        toast.success(resp.msg, toastConfig);
        socket.emit("addMark", {
          idmark: selectedOptionId,
          id_us: info.id_user,
        });
      } else {
        toast.error(resp.msg, toastConfig);
      }
    }

    handleClose(); // Cerrar modal
  };

  if (loading) return <Spinner />;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Asignar {info.type}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3" controlId="Name">
                <Form.Label>
                  {info.type === "agente"
                    ? "Selecciona un agente"
                    : "Selecciona una etiqueta"}
                </Form.Label>
                <Form.Control
                  as="select"
                  name="etiqueta"
                  onChange={(e) => {
                    setSelectedOptionId(e.target.value);
                  }}
                >
                  {data.length > 0 ? (
                    <>
                      <option value="0" hidden>
                        Selecciona una opción
                      </option>

                      {data.map((item, index) => (
                        <option
                          key={index}
                          value={
                            info.type === "agente" ? item.id_agent : item.id
                          }
                        >
                          {info.type === "agente" ? item.name : item.etiqueta}
                        </option>
                      ))}
                    </>
                  ) : (
                    <option value="0">No hay opciones disponibles</option>
                  )}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" className="fw-bolder" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="primary" className="fw-bolder" onClick={handleSave}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAssign;
